import { BO_GROUPS_LIST_KEY } from "@faire/retailer-shared/orders/consts";
import {
  getBrandOrderGroupsFiltersRequest,
  getBrandOrderGroupsRequest,
} from "@faire/retailer-shared/orders/requests";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { usePrefetchQuery as useTabCountsPrefetchQuery } from "@faire/web-api--source/endpoints/www/api/order/v2/brand-order-group-counts-by-tab/get-hooks";
import {
  usePrefetchQuery_escape_hatch as useBOGroupsFiltersPrefetchQuery,
  getQueryKey_escape_hatch as getBOGroupsFiltersQueryKey,
} from "@faire/web-api--source/endpoints/www/api/order/v2/list-by-brand-order-groups/filters/post-hooks";
import {
  usePrefetchQuery as useBOGroupsPrefetchQuery,
  getQueryKey as getBOGroupsQueryKey,
} from "@faire/web-api--source/endpoints/www/api/order/v2/list-by-brand-order-groups/post-hooks";
import orders, {
  QueryParameters as OrdersParams,
} from "@faire/web-api--source/routes/www/orders";
import { useCallback } from "react";

const PREFETCH_STALE_TIME = 1000 * 60;

export const useMyOrdersPrefetch = () => {
  const { prefetch: nextPrefetch } = useNextRouterContext();
  const ordersRoute = orders();
  const preFetchApis = useMyOrdersApiPrefetch();

  return useCallback(
    (href: string = ordersRoute) => {
      nextPrefetch(href);
      preFetchApis();
    },
    [nextPrefetch, ordersRoute, preFetchApis]
  );
};

const useMyOrdersApiPrefetch = () => {
  const boGroupsRequest = getBrandOrderGroupsRequest(OrdersParams.build({}));
  const prefetchBOGroups = useBOGroupsPrefetchQuery();

  const boGroupsFilterRequest = getBrandOrderGroupsFiltersRequest(
    OrdersParams.build({})
  );
  const prefetchBOGroupsFilters = useBOGroupsFiltersPrefetchQuery();

  const prefetchTabCounts = useTabCountsPrefetchQuery();

  return useCallback(() => {
    prefetchBOGroups(boGroupsRequest, {
      queryKey: [BO_GROUPS_LIST_KEY, ...getBOGroupsQueryKey(boGroupsRequest)],
      staleTime: PREFETCH_STALE_TIME,
    });
    prefetchBOGroupsFilters(boGroupsFilterRequest, {
      queryKey: getBOGroupsFiltersQueryKey(boGroupsFilterRequest),
      staleTime: PREFETCH_STALE_TIME,
    });
    prefetchTabCounts({ queryKey: [], staleTime: PREFETCH_STALE_TIME });
  }, [
    prefetchTabCounts,
    boGroupsRequest,
    prefetchBOGroups,
    boGroupsFilterRequest,
    prefetchBOGroupsFilters,
  ]);
};
